import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/banner-shape-1.png'
import _imports_1 from '@/assets/images/shape-11.png'
import _imports_2 from '@/assets/images/shape-13.png'
import _imports_3 from '@/assets/images/banner-shape-2.png'
import _imports_4 from '@/assets/images/shape-12.png'
import _imports_5 from '@/assets/images/banner-shape-3.png'
import _imports_6 from '@/assets/images/banner-shape-4.png'
import _imports_7 from '@/assets/images/shape-14.png'


const _hoisted_1 = { class: "banner-three-area" }
const _hoisted_2 = { class: "container mw-1685" }
const _hoisted_3 = { class: "position-relative z-1" }
const _hoisted_4 = {
  class: "banner-content-three",
  "data-aos": "fade-in",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "top-title" }, "بث مباشر ذكي بجودة فائقة", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h2", null, "تجربة البث التلفزيوني المستقبلي الذي تبحث عنه", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, " من الملاعب العالمية والبطولات الكبرى وحتى شاشتك مباشرة، استمتع بأقوى باقة قنوات وأفلام ومسلسلات بجودة 4K وثبات تام يضمن لك ولعائلتك تجربة مشاهدة لا تُنسى. ", -1)),
          _createElementVNode("form", {
            class: "check-form position-relative",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redirectToWhatsapp && _ctx.redirectToWhatsapp(...args)), ["prevent"]))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "اكتب استفسارك أو طلب التجربة هنا..."
            }, null, -1),
            _createElementVNode("button", {
              type: "submit",
              class: "btn active position-absolute top-50 start-0 translate-middle-y"
            }, [
              _createElementVNode("span", { class: "border-style" }, "تواصل الآن")
            ], -1)
          ]))], 32),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "already" }, [
            _createTextVNode(" هل لديك اشتراك بالفعل وتبحث عن دعم؟ "),
            _createElementVNode("a", {
              href: "https://wa.me/447429916178",
              target: "_blank"
            }, "اضغط هنا للتحدث معنا.")
          ], -1))
        ]),
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"banner-shape banner-shape-1\"><img src=\"" + _imports_0 + "\" alt=\"banner-shape\"><img src=\"" + _imports_1 + "\" class=\"shape-11\" alt=\"shape-11\"><img src=\"" + _imports_2 + "\" class=\"shape-13\" alt=\"shape-13\"></div><div class=\"banner-shape banner-shape-2\"><img src=\"" + _imports_3 + "\" alt=\"banner-shape\"><img src=\"" + _imports_4 + "\" class=\"shape-12\" alt=\"shape-12\"></div><img src=\"" + _imports_5 + "\" class=\"banner-shape banner-shape-3\" alt=\"banner-shape\"><div class=\"banner-shape banner-shape-4\"><img src=\"" + _imports_6 + "\" alt=\"banner-shape\"><img src=\"" + _imports_2 + "\" class=\"shape-13\" alt=\"shape-13\"></div>", 4))
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("img", {
      src: _imports_7,
      class: "shape-14 shape",
      alt: "shape-14"
    }, null, -1)),
    _cache[8] || (_cache[8] = _createElementVNode("img", {
      src: _imports_7,
      class: "shape-15 shape",
      alt: "shape-14"
    }, null, -1)),
    _cache[9] || (_cache[9] = _createElementVNode("img", {
      src: _imports_7,
      class: "shape-16 shape",
      alt: "shape-14"
    }, null, -1))
  ]))
}